import {
  getDrawLineInScene,
  isDrawLineAreaNode,
  isConnectDrawLineNode,
} from '@ps/bridge/qc/base'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { scripts } from '@ps/bridge/qc/scripts'
import { toQcColor } from '@ps/bridge/qc/color'
import gameIframe from '@ps/bridge/iframe/iframe'
import _ from 'lodash'
import store from '@ps/store'

const drawLine = {
  namespaced: true,

  state: {
    pairsData: [], // 配对数据
    areasData: [], // 起止区域数据
    lineDir: 1, // 1单向 2双向, 默认单向
    lineType: 1, // 1轨迹线 2直线，默认轨迹线
    previewing: false, // 预览状态
    pairCategory: [], // 配对类别数据 { uuid, name, nameEn }
    pairCategoryDialogVisible: false, // 配对类别弹窗
    pairCategoryStyle: {
      // 配对类别弹窗样式
      top: '',
      right: '',
    },
  },

  mutations: {
    updateLineDir(state, { lineDir }) {
      state.lineDir = lineDir
      this.dispatch('workspace/game/drawLine/updateDrawLineScriptData')
    },
    updateLineType(state, { lineType }) {
      state.lineType = lineType
      this.dispatch('workspace/game/drawLine/updateDrawLineScriptData')
    },
    updatePairsData(state, { pairsData }) {
      state.pairsData = pairsData
      this.dispatch('workspace/game/drawLine/updateScriptData')
    },
    updateAreasData(state, { areasData }) {
      state.areasData = areasData
      this.dispatch('workspace/game/drawLine/updateScriptData')
    },
    updatePreviewing(state, { previewing }) {
      state.previewing = previewing
    },
    openDialog(state) {
      state.pairCategoryDialogVisible = true
      state.pairCategoryStyle = {
        top: '80px',
        right: 'calc(640px - 100vw)',
      }
    },
    closeDialog(state) {
      state.pairCategoryDialogVisible = false
      state.pairCategoryStyle = {
        top: '',
        right: '',
      }
    },
    updatePairCategory(state, { pairCategory }) {
      state.pairCategory = pairCategory
      this.dispatch('workspace/game/drawLine/updatePairCategoryScriptData')
    },
  },

  actions: {
    initData({ state, rootState }, node) {
      state.pairsData = []
      state.areasData = []
      state.pairCategory = []
      state.pairCategoryDialogVisible = false
      state.lineDir = 1
      state.lineType = 1
      state.previewing = false
      const sceneNode =
        node || rootState.workspace.game.sceneManager.currentSceneNode
      const drawLineNode = getDrawLineInScene(sceneNode)
      if (drawLineNode) {
        const data = editorScript.getScript(drawLineNode)
        if (data.$data.drawLineData) {
          state.pairsData = JSON.parse(data.$data.drawLineData)
        }
        if (data.$data.drawLinePairCategory) {
          state.pairCategory = data.$data.drawLinePairCategory || []
        }
        const dlc = drawLineNode.getScript(scripts.drawLine.name)
        state.lineDir = dlc.pairingDirection === 'oneWay' ? 1 : 2
        state.lineType = dlc.lineType === 'pathLine' ? 1 : 2

        drawLineNode.children.forEach((areaNode) => {
          const dlac = areaNode.getScript(scripts.drawLineArea.name)
          const rgb = dlac.brushColor.rgb
          state.areasData.push({
            name: areaNode.name,
            lineColor: `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 1)`,
            lineSize: dlac.brushSize,
          })
        })
        const dl = drawLineNode.getScript(scripts.drawLine.name)
        dl.clear()
      }
    },
    updateDrawLineScriptData({ state, rootState }) {
      const sceneNode = rootState.workspace.game.sceneManager.currentSceneNode
      const drawLineNode = getDrawLineInScene(sceneNode)
      const dlc = drawLineNode.getScript(scripts.drawLine.name)
      dlc.pairingDirection = state.lineDir === 1 ? 'oneWay' : 'bothWay'
      dlc.lineType = state.lineType === 1 ? 'pathLine' : 'straightLine'
    },
    updateScriptData({ state, rootState }, node) {
      const sceneNode =
        node || rootState.workspace.game.sceneManager.currentSceneNode
      const drawLineNode = getDrawLineInScene(sceneNode)
      if (!drawLineNode) return
      const data = editorScript.getScript(drawLineNode)
      data.$data.drawLineData = JSON.stringify(state.pairsData)

      const info = {}
      state.pairsData.forEach((item) => {
        if (item.startArea !== '') {
          if (!info[item.startArea]) {
            info[item.startArea] = {}
          }
          if (!info[item.startArea].notAllowLineAgain) {
            info[item.startArea].notAllowLineAgain = item.notAllowLineAgain
          }
          if (!info[item.startArea].matchNodes) {
            info[item.startArea].matchNodes = []
          }
          item.endArea.forEach((name) => {
            if (info[item.startArea].matchNodes.indexOf(name) === -1) {
              info[item.startArea].matchNodes.push(name)
            }
          })
        }
        // 双向的情况
        if (state.lineDir === 2 && item.endArea.length > 0) {
          item.endArea.forEach((area) => {
            if (!info[area]) {
              info[area] = {}
            }
            if (!info[area].notAllowLineAgain) {
              info[area].notAllowLineAgain = item.notAllowLineAgain
            }
            if (!info[area].matchNodes) {
              info[area].matchNodes = []
            }
            if (
              item.startArea !== '' &&
              info[area].matchNodes.indexOf(item.startArea) === -1
            ) {
              info[area].matchNodes.push(item.startArea)
            }
          })
        }
      })
      // 先重置初始值
      drawLineNode.children.forEach((areaNode) => {
        const dlac = areaNode.getScript(scripts.drawLineArea.name)
        const Color = gameIframe.qc.Color
        dlac.brushColor = new Color('rgba(0, 0, 0, 1)')
        dlac.brushSize = 10
        dlac.disableDrawAgain = true
        dlac.matchNodes = []
        dlac.enableDraw = false
      })
      for (const i in info) {
        const dlac = drawLineNode
          .getChild(i)
          .getScript(scripts.drawLineArea.name)
        dlac.disableDrawAgain = info[i].notAllowLineAgain
        dlac.matchNodes = info[i].matchNodes.map((name) => {
          return drawLineNode.getChild(name)
        })
        dlac.enableDraw = true
      }
      state.areasData.forEach((area) => {
        const dlac = drawLineNode
          .getChild(area.name)
          .getScript(scripts.drawLineArea.name)
        dlac.brushColor = toQcColor(area.lineColor)
        dlac.brushSize = Number(area.lineSize)
      })
    },
    addNodeForPairsData({ state, commit }, node) {
      if (isDrawLineAreaNode(node)) {
        const data = {
          name: node.name,
          lineColor: 'rgba(0,0,0,1)',
          lineSize: 10,
        }
        state.areasData.push(data)
        commit('updateAreasData', { areasData: _.cloneDeep(state.areasData) })
      }
    },
    copyNodeForPairsData({ state, commit }, node) {
      if (isDrawLineAreaNode(node)) {
        const dla = node.getScript(scripts.drawLineArea.name)
        const data = {
          name: node.name,
          lineColor: dla.brushColor,
          lineSize: dla.brushSize,
        }
        state.areasData.push(data)
        commit('updateAreasData', { areasData: _.cloneDeep(state.areasData) })
      }
    },
    // 删除连线组件和区域子节点联动数据处理
    removeNodeForPairsData({ state, rootState, commit, dispatch }, node) {
      if (isDrawLineAreaNode(node)) {
        state.pairsData.forEach((pair) => {
          if (pair.startArea === node.name) {
            pair.startArea = ''
          }
          pair.endArea = pair.endArea.filter((name) => name !== node.name)
        })
        state.areasData = state.areasData.filter(
          (area) => area.name !== node.name,
        )
        commit('updatePairsData', { pairsData: _.cloneDeep(state.pairsData) })
        commit('updateAreasData', { areasData: _.cloneDeep(state.areasData) })
      } else if (isConnectDrawLineNode(node)) {
        state.pairsData = []
        state.areasData = []
        commit('updatePairsData', { pairsData: _.cloneDeep(state.pairsData) })
        commit('updateAreasData', { areasData: _.cloneDeep(state.areasData) })
      }
    },
    updatePairCategoryScriptData({ state, rootState }, node) {
      const sceneNode =
        node || rootState.workspace.game.sceneManager.currentSceneNode
      const drawLineNode = getDrawLineInScene(sceneNode)
      if (!drawLineNode) return
      const data = editorScript.getScript(drawLineNode)
      data.$data.drawLinePairCategory = state.pairCategory
    },
    addPairCategory({ state, commit }, { category }) {
      const uuid = gameIframe.qcGame.math.uuid()
      state.pairCategory.push({
        uuid,
        name: category,
        nameEn: category,
      })
      commit('updatePairCategory', {
        pairCategory: state.pairCategory,
      })
    },
    deletePairCategory({ state, commit }, { uuid }) {
      state.pairCategory = state.pairCategory.filter((cat) => cat.uuid !== uuid)
      commit('updatePairCategory', {
        pairCategory: state.pairCategory,
      })
      store.dispatch(
        'workspace/game/visualProgram/removePairCategoryForEvent',
        {
          uuid,
        },
      )
      state.pairsData.forEach((pair) => {
        if (pair.pairCategory === uuid) {
          pair.pairCategory = null
        }
      })
      commit('updatePairsData', { pairsData: state.pairsData })
    },
    editPairCategory({ state, commit }, { uuid, newCategory }) {
      const index = state.pairCategory.findIndex((cat) => cat.uuid === uuid)
      if (index >= 0) {
        state.pairCategory[index].name = newCategory
        state.pairCategory[index].nameEn = newCategory
        // 预留中英翻译口子,暂时不做中英版本区分
        // const lang = language.get()
        // if (lang === 'zh-cn') {
        //   state.pairCategory[index].name = newCategory
        // } else {
        //   state.pairCategory[index].nameEn = newCategory
        // }
      }
      commit('updatePairCategory', {
        pairCategory: state.pairCategory,
      })
    },
    // 给配对设置类别
    setPairCategory({ state, commit }, { uuid, categoryUuid }) {
      state.pairsData.forEach((pair) => {
        if (pair.uuid === uuid) {
          pair.pairCategory = categoryUuid
        }
      })
      commit('updatePairsData', { pairsData: state.pairsData })
    },
  },
}

export default drawLine
